import React, { useState } from 'react';
import { ChevronDown, Plus, Minus } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: 'How does Berry ensure my financial data is secure?',
  answer: 'Security is our top priority. We use bank-level 256-bit encryption for all data transmission and storage. We are SOC 2 Type II compliant and never sell your data to third parties. Your credentials are tokenized and we have read-only access to your bank feeds.'
}, {
  question: 'Which accounting software do you integrate with?',
  answer: 'Berry seamlessly integrates with major accounting platforms including QuickBooks Online, Xero, FreshBooks, and Zoho Books. We also support direct connections to over 10,000 financial institutions for real-time transaction importing.'
}, {
  question: 'Can I upgrade or downgrade my plan later?',
  answer: 'Yes, absolutely. You can upgrade or downgrade your plan at any time from your dashboard. If you upgrade, the change happens immediately. If you downgrade, the new rate starts at the beginning of your next billing cycle.'
}, {
  question: 'What happens if I exceed my transaction limit?',
  answer: "If you exceed your plan's transaction limit, we'll notify you. You can choose to upgrade to the next tier or pay a small overage fee per transaction. We won't pause your service or stop syncing your data without warning."
}, {
  question: 'Do you support multi-currency reconciliation?',
  answer: 'Yes, the Professional plan includes full multi-currency support. Berry automatically handles currency conversion based on daily exchange rates and flags any discrepancies due to exchange rate fluctuations.'
}, {
  question: 'Is there a setup fee or long-term contract?',
  answer: 'No. All our plans are month-to-month (unless you choose annual billing for a discount) and there are no hidden setup fees. You can cancel your subscription at any time without penalty.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-24 bg-gray-50" data-id="element-108">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <div className="text-center mb-16" data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-111">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600" data-id="element-112">
            Everything you need to know about automating your reconciliation.
          </p>
        </div>

        <div className="space-y-4" data-id="element-113">
          {faqs.map((faq, index) => <div key={index} className={`bg-white rounded-2xl border transition-all duration-200 ${openIndex === index ? 'border-violet-200 shadow-md ring-1 ring-violet-100' : 'border-gray-200 hover:border-violet-200'}`} data-id="element-114">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-115">
                <span className={`text-lg font-bold transition-colors ${openIndex === index ? 'text-violet-900' : 'text-gray-900'}`} data-id="element-116">
                  {faq.question}
                </span>
                <span className={`ml-6 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-117">
                  <ChevronDown className={`h-5 w-5 ${openIndex === index ? 'text-violet-600' : 'text-gray-400'}`} data-id="element-118" />
                </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-119">
                <div className="px-6 pb-6 text-gray-600 leading-relaxed" data-id="element-120">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-121">
          <p className="text-gray-600" data-id="element-122">
            Still have questions?{' '}
            <a href="#" className="text-violet-600 font-bold hover:text-violet-700 underline decoration-2 underline-offset-2" data-id="element-123">
              Chat with our team
            </a>
          </p>
        </div>
      </div>
    </section>;
}